import { useState } from "react";
import * as s from "styles/ModalCommonStyled";
import {
  SearchRecorderList,
  SelectedRowWithAddress,
} from "./SearchRecorderList";
import { SearchRecorderGroup } from "./SearcRecorderGroup";
import DebounceSearchInput from "components/atoms/input/search/DebounceSearchInput";
import Tabs from "components/atoms/tabs/Tabs";

export type SearchRecorderProps = {
  accountId: string;
  onSelectedRowsChange?: (selectedRows: string[]) => void;
  onSelectedGroupRowsChange?: (selectedRows: number[]) => void;
  onSelectRowChangeAddress?: (row: SelectedRowWithAddress) => void;
  selectedRow?: string[] | string;
  selectedGroupRow?: number[];
  isTab?: boolean;
  isSingleMode?: boolean;
  isDisabled?: boolean;
  userId: string | undefined;
  hideTitle?: boolean;
  useRowExpandedSelection?: boolean;
};

export interface DataRow {
  id: string;
  name: string;
  cameras: number;
  location: string;
}

const enum RECORDER_MENU {
  SYSTEMS = "systems",
  RECORDER_GROUPS = "recorderGroups",
}

export function SearchRecorder(props: SearchRecorderProps): JSX.Element {
  const [searchText, setSearchText] = useState<string>("");
  const onClickSearch = (keyword: string) => {
    setSearchText(keyword);
  };
  // step 0 - recorders sub menu
  const recorderMenus = [
    {
      label: `Add Systems (${
        !props.isSingleMode
          ? props.selectedRow !== undefined
            ? props.selectedRow?.length
            : 0
          : 0
      })`,
      value: RECORDER_MENU.SYSTEMS,
    },
    {
      label: `Add Recorder Groups (${
        props.selectedGroupRow !== undefined
          ? props.selectedGroupRow?.length
          : 0
      })`,
      value: RECORDER_MENU.RECORDER_GROUPS,
    },
  ];

  const [currentMenu, setCurrentMenu] = useState<RECORDER_MENU>(
    RECORDER_MENU.SYSTEMS
  );
  const onChangeMenu = (value: string) => {
    setCurrentMenu(value as RECORDER_MENU);
  };

  return (
    <>
      {props.isTab ? (
        <s.ModalTabSearchWrapper>
          <Tabs
            tabs={recorderMenus}
            currentTab={currentMenu}
            onChangeTab={onChangeMenu}
          />
          <div className="search-box">
            {/* search input group, individual 공통으로 검색되도록 */}
            <DebounceSearchInput
              placeholder="Select Recorder"
              onClickSearch={onClickSearch}
              data-testid="search-recorder-input"
            />
          </div>
        </s.ModalTabSearchWrapper>
      ) : (
        <DebounceSearchInput
          placeholder="Select Recorder"
          onClickSearch={onClickSearch}
          data-testid="search-recorder-input"
        />
      )}

      <s.ModalTableContainer className="search-recorder-container">
        {currentMenu === RECORDER_MENU.SYSTEMS && (
          <div>
            {!props.isTab && !props.hideTitle && (
              <div className="search-title">
                {props.isSingleMode ? "Select Recorder" : "Select Recorders"}
              </div>
            )}
            <SearchRecorderList
              accountId={props.accountId}
              search={searchText}
              selectedRow={props.selectedRow}
              onSelectedRowsChange={props.onSelectedRowsChange}
              onSelectRowChangeAddress={props.onSelectRowChangeAddress}
              isSingleMode={props.isSingleMode}
              isDisabled={props.isDisabled}
              userId={props.userId}
              useRowExpandedSelection={props.useRowExpandedSelection}
            />
          </div>
        )}

        {currentMenu === RECORDER_MENU.RECORDER_GROUPS && (
          <div>
            {!props.isTab && (
              <div className="search-title">Select Recorders</div>
            )}
            <SearchRecorderGroup
              accountId={props.accountId}
              search={searchText}
              selectedRecorderGroupRow={props.selectedGroupRow}
              onSelectedRowsChange={props.onSelectedGroupRowsChange}
              userId={props.userId}
              isDisabled={props.isDisabled}
            />
          </div>
        )}
      </s.ModalTableContainer>
    </>
  );
}
